<template>
  <div class="pb-">
    <h5 class="default-font-size mb">Totale pakketscore</h5>
    <div class="layout mb-">
      <div class="layout__item u-1/1">
        <div class="layout">
          <template v-for="(item, index) in resultItem.SupplierAssessment.AssessmentCategories">
            <div :key="index" class="layout__item u-16/24 zeta pb-">{{item.Name}}</div>
            <div
              :key="index +'2'"
              class="layout__item u-8/24 u-text-align--right zeta pb-"
            >{{item.TotalAssessment}}</div>
          </template>
          <div class="layout__item u-16/24 zeta u-weight--bold">Totale pakketscore</div>
          <div
            class="layout__item u-8/24 zeta u-weight--bold u-text-align--right"
          >{{resultItem.SupplierAssessment.AssessmentTotal}}</div>
        </div>
      </div>
    </div>

    <template v-if="isDetail">
      <toggle-details
        v-for="(item, index) in resultItem.SupplierAssessment.AssessmentCategories"
        :key="index"
      >
        <template slot="header">
          <div class="layout">
            <div class="layout__item u-16/24">{{item.Name}}</div>
            <div
              class="layout__item u-8/24 zeta u-text-align--right"
              :class="{'small': item.TotalAssessment === 'Onvoldoende gegevens'}"
            >
              <span
                :class="{'small': item.TotalAssessment === 'Onvoldoende gegevens'}"
                class="c-spec"
              >{{item.TotalAssessment}}</span>
            </div>
          </div>
        </template>
        <template slot="content">
          <div class="u-text-color-grey">{{item.TotalCountText}}</div>
          <div
            class="layout__item u-1/1 pl0 ml0"
            v-for="(assessmentItem, index) in item.AssessmentList"
            :key="index"
          >
            <div class="layout__item u-16/24 zeta pl0 pb-">
              <span v-tooltip="assessmentItem.ToolTip">
                {{assessmentItem.Text}}
                <span class="c-icon-info"></span>
              </span>
              <div class="c-tooltip"></div>
            </div>
            <div
              class="layout__item u-8/24 zeta pb- u-text-align--right"
            >{{assessmentItem ? assessmentItem.Value : ''}}</div>
          </div>
        </template>
      </toggle-details>
    </template>
  </div>
</template>

<script>
import ToggleDetails from './ToggleDetails';
export default {
	props: ['resultItem', 'isDetail'],
	components: { ToggleDetails }
};
</script>

<style>
</style>
